import { Action } from '@ngrx/store';

import * as models from '../../domain/models';

export const LOAD = '[YM Route Groups Data] Load';
export const LOAD_SUCCESS = '[YM Route Groups Data] Load Success';
export const LOAD_FAIL = '[YM Route Groups Data] Load Fail';

export class LoadAction implements Action {
  readonly type = LOAD;
}

export class LoadSuccessAction implements Action {
  readonly type = LOAD_SUCCESS;

  constructor(public payload: Array<models.CustomShuttleRouteGroups>) {}
}

export class LoadFailAction implements Action {
  readonly type = LOAD_FAIL;
}

export type Actions = LoadAction | LoadSuccessAction | LoadFailAction;
